import React from "react";
import { Header } from "@common/components";
import { SkeletonBase } from "@foris/avocado-suite";
import DimensionsSearchSkeleton from "@components/dimensions-search-skeleton";
import styles from "./packages.module.scss";

const PackagesSkeleton = () => {
  return (
    <>
      <Header
        isLoading={{
          title: true,
          subTitle: true,
          topTitle: true,
          moreDetails: true,
          breadcrumb: true,
        }}
      />

      <div className={styles.main}>
        <SkeletonBase width={156} height={24} />

        <div className={styles.selector}>
          <div className={styles.selectorSkeleton}>
            <SkeletonBase width={143} height={14} />
            <SkeletonBase width={405} height={36} />
          </div>

          <SkeletonBase width={136} height={36} />
          <SkeletonBase className={styles.skeletonCreatePackage} width={185} height={36} />
        </div>

        <DimensionsSearchSkeleton showHeader={false} showPagination={false} columns={12} rows={5} />
      </div>
    </>
  );
};

export default PackagesSkeleton;
